/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Image } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Peu après la naissance de son premier veau, Erika a été de nouveau inséminée, elle
passe en fait sa vie en étant en permanence portante. Ensuite, 285 jours plus tard, elle
met bas son deuxième veau qui lui est aussitôt enlevé après la naissance. Erika est
maintenant une vache de deuxième lactation. Par veau vêlé, elle passe à la traite deux
fois quotidiennement pendant 305 jours en moyenne. Lorsqu’elle est en fin de
gestation, Erika est “tarie”, cela revient à lui accorder une pause de traite qui
peut durer jusqu’à huit semaines avant la prochaine mise bas.`}</p>
    <Image file={['laktationszyklus-fr-01.png', 'laktationszyklus-fr-02.png']} title='L’année typique d’une vache laitière' subtitle=' ' source='Source: www.landschafftleben.at' mdxType="Image" />
    <p>{`Erika est une fort belle vache, elle a un bon type comme disent les paysans, une belle
ligne du dos, un pis bas et la position de ses trayons est optimale. Avec de telles
tétines, elle sera sacrée reine dans une foire aux bestiaux. Pour décrocher un prix, les
pis d’Erika ont été bouchés avec du collodion. Des vétérinaires soutiennent que, cette
substance appliqué en plusieurs couches a un effet semblable à celui d’une
colle-contact. Il y a un mois le parlement fédéral a refusé d’interdire le scellement
de tétines. De plus, les bêtes souffrent car pour avoir un beau pis bien rempli, elles ne
passent pas à la traite ce jour-là. Erika est très convoitée. Comme vache laitière sans
défaut, elle est vendue pour 3200 francs et transportée dans une autre ferme.`}</p>
    <Image file={['viehschau-fr-01.png', 'viehschau-fr-02.png']} title='Composition de la note globale d’une exposition bovine' subtitle='' source='' mdxType="Image" />
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  